import { ProtectedRoutes, SplitLayout } from '@components/layout';
import { APP_PREFIX_PATH } from '@constants/common';
import { useAppSelector } from '@hooks/generic';
import useGTM from '@hooks/useGTM';
import { Navigate, Route, Routes, useLocation } from 'react-router-dom';
import { DashboardViews } from 'src/routes/dashboard/DashboardViews';
import { Error } from 'src/routes/Error';
import { Forbidden } from 'src/routes/Forbidden';
import { NotFound } from 'src/routes/NotFound';
import { PublicViews } from 'src/routes/public/PublicViews';
import { Unauthenticated } from 'src/routes/Unauthenticated';

const Views = () => {
    const location = useLocation();
    const error = useAppSelector((store) => store.error.status);

    // Initialize GTM tracking for all pages
    useGTM();

    return !error ? (
        <Routes>
            <Route
                path={APP_PREFIX_PATH + '/*'}
                element={
                    <Routes>
                        <Route element={<ProtectedRoutes />}>
                            <Route path="/dashboard/*" element={<DashboardViews />} />
                        </Route>
                        <Route
                            path="/forbidden"
                            element={
                                <SplitLayout>
                                    <Forbidden />
                                </SplitLayout>
                            }
                        />
                        <Route path="/not-found" element={<NotFound fullPage />} />
                        <Route path="/*" element={<PublicViews />} />
                        <Route path="*" element={<NotFound fullPage />} />
                    </Routes>
                }
            />
            <Route
                path="*"
                element={
                    <Navigate to={APP_PREFIX_PATH + location.pathname + location.search + location.hash} replace />
                }
            />
        </Routes>
    ) : error === 403 ? (
        <SplitLayout>
            <Forbidden />
        </SplitLayout>
    ) : error === 401 ? (
        <Unauthenticated />
    ) : error === 404 ? (
        <NotFound fullPage />
    ) : (
        <Error />
    );
};

export { Views };
